import { render, staticRenderFns } from "./SelectProjectTypeStepItem.vue?vue&type=template&id=e6a66b72&"
import script from "./SelectProjectTypeStepItem.vue?vue&type=script&lang=js&"
export * from "./SelectProjectTypeStepItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports